import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { Document, Page } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { QueryFunction } from '@tanstack/react-query';
import { getDocumentPages } from './getDocumentTypeMetadata';

interface GetTrashedDocumentsResponse {
  documents: Document[];
  count: number;
  status: string;
}

const getTrashedDocuments: QueryFunction<
  GetTrashedDocumentsResponse,
  ['/documents/trash', string]
> = async ({ queryKey }) => {
  const loanId = queryKey[1];
  if (isMockServices()) return await mock(_mockTrashedDocuments(loanId));

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetTrashedDocumentsResponse>(
    `/loans/${loanId}/documents/trash`,
    {
      method: 'GET',
    },
  );

  if (response.data) {
    for (const document of response.data.documents) {
      const pages = await getDocumentPages(document.id, true);
      document.pages = pages.pages as Page[];
    }
    return response.data;
  }

  throw new Error('Failed to fetch trashed documents');
};

export default getTrashedDocuments;

const _mockTrashedDocuments = (loanId: string) => ({
  documents: new Array(10).fill(null).map((_, index) => ({
    id: `document-${index}`,
    name: `Document ${index + 1}`,
    loanId: loanId,
    confidence: 100,
    version: 1,
    versionIdentifier: `version-${index + 1}`,
    pages: [],
    documentTypeId: `document-type-${index + 1}`,
    documentTypeConfidence: 100,
    isDeleted: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    isNew: false,
    isVerified: false,
    isViewed: false,
    userApproved: false,
    fields: [],
    userTasks: [],
    documentPages: [],
    metadata: {
      external_document_filename: `document-${index + 1}.pdf`,
    },
    documentType: {
      id: `document-type-${index + 1}`,
      name: `Document Type ${index + 1}`,
      displayName: `Document Type ${index + 1}`,
      fields: [],
      filenamePrefix: null,
      classificationReviewThreshold: 0,
      extractionReviewThreshold: 0,
      borrowerReviewThreshold: 0,
      highConfThresh: 0,
    },
  })) as Document[],
  count: 10,
  status: 'success',
});
